export default "__VITE_ASSET__D911_xdZ__"